import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverListAssignmentEntity } from '../../domain/entities/DriverListAssignmentEntity'

export class DriverListAssignmentModel extends DriverListAssignmentEntity {
  constructor(dataDto: DriverListAssignmentModel) {
    super()
    mapEntityProperties<DriverListAssignmentEntity>(this, dataDto)
  }
}

